import CumulativeAnalysisDashboard from '../components/statistics/CumulativeAnalysisDashboard';

function StatisticsCumulativePage() {
  return <CumulativeAnalysisDashboard />;
}

export default StatisticsCumulativePage;
